import { ArrowRight } from "lucide-react";
import { Logo } from "./Logo";

export function PublicHeader({ maxWidthClass = "max-w-5xl", showSignIn = true }) {
  return (
    <header
      className={`${maxWidthClass} mx-auto px-5 pt-[max(1.5rem,calc(env(safe-area-inset-top)+1rem))] pb-6 ${
        showSignIn ? "flex items-center justify-between" : ""
      }`}
    >
      <a href="/" className="inline-flex items-center gap-2"><Logo markSize={30} textSize="text-xl" /></a>
      {showSignIn && (
        <div className="flex items-center gap-1 sm:gap-3">
          <a href="/login" data-testid="public-login-link" className="text-sm font-medium text-ink/60 hover:text-ink px-2 py-2">
            Log in
          </a>
          <a
            href="/login?mode=register"
            data-testid="public-signup-link"
            className="inline-flex h-9 items-center rounded-lg bg-tea px-3 text-sm font-medium text-tea-text hover:bg-tea-hover transition-[background-color,transform] duration-200 active:scale-[0.96]"
          >
            Sign up
          </a>
        </div>
      )}
    </header>
  );
}

export function PublicFooter({ maxWidthClass = "max-w-5xl" }) {
  return (
    <footer className={`${maxWidthClass} mx-auto flex items-center justify-between gap-4 px-5 pb-8 text-xs text-ink/35`}>
      <span>© 2026 Mnandi</span>
      <span className="flex flex-wrap justify-end gap-x-4 gap-y-2">
        <a href="/learn/labour-costing" className="hover:text-ink/60">Labour</a>
        <a href="/learn/yield" className="hover:text-ink/60">Yield</a>
        <a href="/terms" className="hover:text-ink/60">Terms</a>
        <a href="/privacy" className="hover:text-ink/60">Privacy</a>
      </span>
    </footer>
  );
}

export function PublicSignupCTA({ eyebrow, heading, body, testId }) {
  return (
    <div className="rounded-[20px] bg-surface border border-sand p-6 sm:p-8 max-w-2xl">
      <p className="text-xs uppercase tracking-[0.2em] font-medium text-ink/50">{eyebrow}</p>
      <h2 className="font-heading font-bold text-2xl sm:text-3xl tracking-tight mt-1">{heading}</h2>
      <p className="mt-3 text-sm text-ink/60 max-w-md">{body}</p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <a href="/login?mode=register" data-testid={testId}
          className="group flex h-12 items-center justify-center gap-2 rounded-lg bg-tea hover:bg-tea-hover text-tea-text font-medium px-6 transition-[background-color,transform] duration-200 active:scale-[0.96]">
          Create your free account <ArrowRight size={17} className="transition-transform duration-200 group-hover:translate-x-0.5" />
        </a>
        <a href="/login" className="flex h-12 items-center justify-center rounded-lg border border-sand bg-white px-6 text-sm font-medium text-ink/70 hover:bg-sand/40 transition-colors duration-150">
          Already have an account? Sign in
        </a>
      </div>
      <p className="mt-4 text-xs text-ink/40">Cost up to 2 real recipes free for 14 days. No card required. Add a card any time before it ends.</p>
    </div>
  );
}

export function GuideStepStrip({ label, steps }) {
  return (
    <div className="overflow-x-auto pb-2">
      <ol className="flex min-w-max items-center gap-2" aria-label={label}>
        {steps.map(({ label: stepLabel, icon: Icon }, index) => (
          <li key={stepLabel} className="flex items-center gap-2">
            <span className="inline-flex h-10 items-center gap-2 rounded-full border border-sand bg-white px-4 text-sm font-medium text-ink/70">
              <Icon size={16} strokeWidth={2} className="text-tea-text" aria-hidden="true" />
              {stepLabel}
            </span>
            {index < steps.length - 1 && <ArrowRight size={16} className="text-ink/25" aria-hidden="true" />}
          </li>
        ))}
      </ol>
    </div>
  );
}
